import React from "react";
import { PlayCircle } from "lucide-react";
import { toEmbedUrl } from "../VideoModal";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export function resolveVideoSrc(url) {
  if (!url) return null;
  return url.startsWith("/api/") ? `${BACKEND}${url}` : url;
}

// Embedded player for an option: YouTube / Vimeo / Loom iframe, direct MP4 <video>, or a "coming soon" placeholder.
export function TiqVideo({ url, title, color }) {
  const src = resolveVideoSrc(url);
  if (!src) {
    return (
      <div className="aspect-video w-full border border-dashed border-white/15 bg-[#101010] grid place-items-center text-center" data-testid="tiq-video-placeholder">
        <div>
          <PlayCircle className="w-9 h-9 mx-auto mb-2 opacity-40" style={{ color }} />
          <div className="text-[10px] uppercase tracking-[0.3em] text-[#757575]">Video coming soon</div>
        </div>
      </div>
    );
  }
  const embed = toEmbedUrl(src);
  if (embed && !src.startsWith(BACKEND)) {
    return (
      <div className="aspect-video w-full bg-black" data-testid="tiq-video-embed">
        <iframe src={embed.replace("autoplay=1", "autoplay=0")} title={title} className="w-full h-full border-0" allow="accelerometer; autoplay; encrypted-media; picture-in-picture" allowFullScreen />
      </div>
    );
  }
  return (
    <div className="aspect-video w-full bg-black" data-testid="tiq-video-file">
      <video src={src} controls playsInline preload="metadata" className="w-full h-full" />
    </div>
  );
}
